import { DateTime } from "luxon";
import { DueDateProperty } from "src/components";
import { TaskItemDetailDto, useEditTaskItemDueDate } from "src/http";

interface IProps {
  taskItem: TaskItemDetailDto;
}

const TaskItemDueDateProperty = (props: IProps) => {
  const { mutate: editDueDate, isLoading } = useEditTaskItemDueDate();

  function handleSaveClicked(dueDate: DateTime | null) {
    editDueDate({
      taskItemGuid: props.taskItem.guid,
      dueDate:
        dueDate != null
          ? DateTime.fromObject({
              year: dueDate.year,
              month: dueDate.month,
              day: dueDate.day,
              hour: 23,
              minute: 59,
              second: 59,
            }).toISO({
              includeOffset: false,
            })
          : null,
      teamSlug: props.taskItem.team?.slug,
      ownerUserGuids: props.taskItem.owners.map((x) => x.user.userId),
    });
  }

  return (
    <DueDateProperty
      dueDate={props.taskItem.dueDate}
      userCanEdit={props.taskItem.userCanEdit}
      disabled={isLoading}
      onSaveClicked={handleSaveClicked}
    />
  );
};

export { TaskItemDueDateProperty };
